<template>
  <div id="imgWrapper">
    <img
      class="picImg"
      v-if="src === ''"
      style="width: 100%;height: 100%;"
      src="../../assets/bglogo.png"
    />
    <img
      class="picImg"
      v-else
      ref="img"
      :src="loadingSrc"
      :origin-url="originUrl"
      :alt="alt"
    />
  </div>
</template>

<script>
export default {
  name: "Thumb",
  components: {},
  props: {
    src: {
      type: String,
      default: ""
    },
    originUrl: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      errorSrc: require("../../assets/img_load_fail.svg"),
      loadingSrc: require("../../assets/loading.svg")
    };
  },
  watch: {
    src(val) {
      this.loadingSrc = val;
    }
  },
  computed: {},
  mounted() {
    let _this = this;
    let sizeSrc = this.src + "";
    if (sizeSrc !== "") {
      if (sizeSrc.indexOf("?") !== -1) {
        _this.loadingSrc =
          _this.src +
          "&x-oss-process=image/resize,m_fill,w_" +
          (document.getElementById("imgWrapper").offsetWidth || 100) +
          ",h_" +
          (document.getElementById("imgWrapper").offsetHeight || 100);
      } else {
        _this.loadingSrc =
          _this.src +
          "?&x-oss-process=image/resize,m_fill,w_" +
          (document.getElementById("imgWrapper").offsetWidth || 100) +
          ",h_" +
          (document.getElementById("imgWrapper").offsetHeight || 100);
      }
    }
  },
  methods: {}
};
</script>

<style scoped>
img {
  overflow: hidden;
}

.picImg {
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
}
</style>
